var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 0.292893C0 0.585786 0 1.05719 0 2V8C0 8.94281 0 9.41421 0.292893 9.70711C0.585786 10 1.05719 10 2 10H11.05C11.5638 10 11.8207 10 12.0388 9.88563C12.2569 9.77126 12.403 9.55996 12.6952 9.13736L14.7692 6.13736C15.1496 5.58714 15.3398 5.31202 15.3398 5C15.3398 4.68798 15.1496 4.41286 14.7692 3.86264L12.6952 0.862636C12.403 0.440039 12.2569 0.22874 12.0388 0.11437C11.8207 0 11.5638 0 11.05 0H2C1.05719 0 0.585786 0 0.292893 0.292893ZM10.4771 6.58488C11.3976 6.58488 12.1438 5.83869 12.1438 4.91821C12.1438 3.99774 11.3976 3.25155 10.4771 3.25155C9.55663 3.25155 8.81044 3.99774 8.81044 4.91821C8.81044 5.83869 9.55663 6.58488 10.4771 6.58488Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLabel);
export default __webpack_public_path__ + "static/media/ic_label.6f78471daf5628d580b6c05efb041fa3.svg";
export { ForwardRef as ReactComponent };